export enum NylasScope {
    email = 1,
    calendar = 2
}
